<template>
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="isOpen"
      persistent
      max-width="1000px"
    >
      <v-card class="create-bridge-signing">
        <v-form v-if="bridgeSigning">
          <v-card-title class="toolbar primary white--text">
            <v-icon dark>
              edit
            </v-icon>
            <h3 class="title ml-2">
              Edit bridge signing
            </h3>
            <v-spacer />
          </v-card-title>
          <v-progress-linear
            v-if="isLoading"
            :indeterminate="true"
            class="ma-0"
          />

          <v-card-text>
            <v-container
              grid-list-md
              fluid
              class="pa-0"
            >
              <v-layout
                wrap
                class="form-group"
              >
                <v-flex xs12>
                  <h6 class="subheading">
                    Bridge Signing details
                  </h6>
                </v-flex>

                <v-flex
                  xs12
                  sm6
                  md4
                >
                  <v-text-field
                    :value="bridgeSigning.id"
                    label="Bridge Signing id"
                    disabled
                  />
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md4
                >
                  <v-text-field
                    v-model="bridgeSigning.user_id"
                    label="Id"
                    disabled
                  />
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md4
                >
                  <v-text-field
                    v-model="bridgeSigning.user_id"
                    label="User id"
                    disabled
                  />
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md4
                >
                  <v-text-field
                    v-model="bridgeSigning.detail_id"
                    label="Detail id"
                    disabled
                  />
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md4
                >
                  <v-text-field
                    v-model="bridgeSigning.contract_id"
                    label="Contract id"
                    disabled
                  />
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md4
                >
                  <v-text-field
                    v-model="bridgeSigning.ip"
                    label="Ip"
                    disabled
                  />
                </v-flex>

                <v-flex
                  xs12
                  sm6
                  md3
                >
                  <label class="radio-label">Investment type</label>
                  <v-radio-group
                    v-model="formData.investtype"
                    row
                    :error-messages="getFieldErrors('investtype')"
                    @change="investtypeUpdate"
                  >
                    <v-radio
                      v-for="investtype in investmentTypes"
                      :key="investtype"
                      :value="investtype"
                      :label="investtype"
                      color="primary"
                    />
                  </v-radio-group>
                </v-flex>

                <v-flex
                  xs12
                  sm6
                  md3
                >
                  <v-text-field
                    v-model="formData.contract_type"
                    label="Contract type"
                    :error-messages="getFieldErrors('contract_type')"
                    @input="$v.formData.contract_type.$touch()"
                    @blur="$v.formData.contract_type.$touch()"
                  />
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md3
                >
                  <v-text-field
                    v-model="formData.domain"
                    label="Domain"
                    :error-messages="getFieldErrors('domain')"
                    @input="$v.formData.domain.$touch()"
                    @blur="$v.formData.domain.$touch()"
                  />
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md3
                >
                  <v-text-field
                    v-model="formData.pieces"
                    label="Pieces"
                    type="number"
                    :error-messages="getFieldErrors('pieces')"
                    @input="$v.formData.pieces.$touch()"
                    @blur="$v.formData.pieces.$touch()"
                  />
                </v-flex>

                <v-flex
                  xs12
                  sm6
                  md3
                >
                  <v-menu
                    v-model="pickerAcceptDateOpen"
                    :close-on-content-click="false"
                    full-width
                    max-width="290"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="formData.contract_accepted_at"
                        label="Contract accepted at"
                        append-icon="event"
                        readonly
                        :error-messages="getFieldErrors('contract_accepted_at')"
                        v-on="on"
                        @change="$v.formData.contract_accepted_at.$touch()"
                        @blur="$v.formData.contract_accepted_at.$touch()"
                      />
                    </template>
                    <v-date-picker
                      v-model="formData.contract_accepted_at"
                      :max="todaysDate"
                      show-current
                      color="info"
                      @change="pickerAcceptDateOpen = false"
                    />
                  </v-menu>
                </v-flex>

                <v-flex
                  xs12
                  sm6
                  md3
                >
                  <v-menu
                    v-model="pickerPaidDateOpen"
                    :close-on-content-click="false"
                    full-width
                    max-width="290"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="formData.paid_at"
                        label="Contract paid at"
                        append-icon="event"
                        readonly
                        :error-messages="getFieldErrors('paid_at')"
                        v-on="on"
                        @change="$v.formData.paid_at.$touch()"
                        @blur="$v.formData.paid_at.$touch()"
                      />
                    </template>
                    <v-date-picker
                      v-model="formData.paid_at"
                      :max="todaysDate"
                      show-current
                      color="info"
                      @change="pickerPaidDateOpen = false"
                    />
                  </v-menu>
                </v-flex>

                <v-flex
                  xs12
                  sm6
                  md3
                >
                  <v-menu
                    v-model="pickerRepaidDateOpen"
                    :close-on-content-click="false"
                    full-width
                    max-width="290"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="formData.repaid_at"
                        label="Contract repaid at"
                        append-icon="event"
                        readonly
                        :error-messages="getFieldErrors('repaid_at')"
                        v-on="on"
                        @change="$v.formData.repaid_at.$touch()"
                        @blur="$v.formData.repaid_at.$touch()"
                      />
                    </template>
                    <v-date-picker
                      v-model="formData.repaid_at"
                      :max="todaysDate"
                      show-current
                      color="info"
                      @change="pickerRepaidDateOpen = false"
                    />
                  </v-menu>
                </v-flex>

                <v-flex
                  xs12
                  sm6
                  md3
                >
                  <v-menu
                    v-model="pickerTerminatedDateOpen"
                    :close-on-content-click="false"
                    full-width
                    max-width="290"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="formData.contract_terminated_at"
                        label="Contract terminated at"
                        append-icon="event"
                        readonly
                        :error-messages="getFieldErrors('contract_terminated_at')"
                        v-on="on"
                        @change="$v.formData.contract_terminated_at.$touch()"
                        @blur="$v.formData.contract_terminated_at.$touch()"
                      />
                    </template>
                    <v-date-picker
                      v-model="formData.contract_terminated_at"
                      :max="todaysDate"
                      show-current
                      color="info"
                      @change="pickerTerminatedDateOpen = false"
                    />
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-container>
            <v-alert
              v-if="error"
              :value="error"
              type="error"
              color="error"
            >
              {{ error }}
            </v-alert>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn
              color="secondary"
              flat
              @click="onToggleOpen"
            >
              Cancel
            </v-btn>
            <v-tooltip
              top
              dark
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  :disabled="isLoading || !$v.formData.$anyDirty"
                  :loading="isLoading"
                  color="primary"
                  @click="submit"
                  v-on="on"
                >
                  <span>Edit Bridge Signing</span>
                </v-btn>
              </template>
              <span>Validate and submit</span>
            </v-tooltip>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { investmentTypes } from '@/enum/bridgeSigning/BridgeSigningEnum';

export default {
  name: 'EditBridgeSigningDialog',

  props: {
    bridgeSigning: {
      type: Object,
      required: true,
    },
    isOpen: {
      type: Boolean,
      required: true,
    },
    toggleOpen: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    isLoading: false,
    pickerAcceptDateOpen: false,
    pickerTerminatedDateOpen: false,
    pickerPaidDateOpen: false,
    pickerRepaidDateOpen: false,
    error: null,
    investmentTypes,
    todaysDate: new Date().toISOString().substr(0, 10),
    formData: {
      id: null, // '123'
      contract_type: null, // '70248',
      investtype: null, //  '1',
      domain: null, // 'DEU',
      pieces: null, // 'prepay',
      paid_at: null, // '2019-09-30',
      repaid_at: null, // '2019-09-30',
      contract_accepted_at: null, // '2019-09-30',
      contract_terminated_at: null, // '2019-09-30',
    },
  }),

  validations() {
    const validations = {
      formData: {
        id: { required }, // id is always required
        contract_type: {},
        investtype: {},
        domain: {},
        pieces: {},
        contract_accepted_at: {},
        contract_terminated_at: {},
        paid_at: {},
        repaid_at: {},
      },
    };

    if (this.isOpen) {
      /**
       * some fields come as null from the BE (ex: 'contract_terminated_at' or 'repaid_at')
       * check fields one by one and make them required if they have any value
       */
      if (this.formData.contract_type) {
        validations.formData.contract_type = { required };
      }
      if (this.formData.investtype) {
        validations.formData.investtype = { required };
      }
      if (this.formData.pieces) {
        validations.formData.pieces = { required };
      }
      if (this.formData.contract_accepted_at) {
        validations.formData.contract_accepted_at = { required };
      }
      if (this.formData.contract_terminated_at) {
        validations.formData.contract_terminated_at = { required };
      }
      if (this.formData.paid_at) {
        validations.formData.paid_at = { required };
      }
      if (this.formData.repaid_at) {
        validations.formData.repaid_at = { required };
      }
    }

    return validations;
  },

  computed: {
    validFields() {
      return Object.keys(this.$v.formData.$params).filter(
        item => !this.$v.formData[item].$invalid,
      );
    },
    errors() {
      return Object.keys(this.$v.formData.$params).filter(
        item => this.$v.formData[item].$invalid,
      );
    },
  },
  watch: {
    bridgeSigning(item) {
      // map all form data to bridgeSigning object and reset form validation
      Object.keys(this.formData).map((key) => {
        this.formData[key] = item[key];

        return key;
      });
      this.$v.$reset();
    },
  },
  methods: {
    getFieldErrors(field) {
      const errors = [];
      if (this.$v.formData[field]) {
        if (!this.$v.formData[field].$dirty || !this.$v.formData[field].$invalid) {
          return errors;
        }

        if (!this.$v.formData[field].required) {
          errors.push('Required field');
        }
      }

      return errors;
    },
    investtypeUpdate(value) {
      this.formData.investtype = value;
      this.$v.formData.investtype.$touch();
    },
    onToggleOpen() {
      this.toggleOpen();
      this.error = null;
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.isLoading = true;
        this.$store
          .dispatch('updateBridgeSigning', { ...this.formData })
          .then((data) => {
            console.info(data);
            this.onToggleOpen();
          })
          .catch((err) => {
            this.error = err;
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
  },
};
</script>

<style lang="scss" >
.create-bridge-signing {
  .flex {
    position: relative;
  }
  .v-card__title {
    padding: 24px;
  }
  .v-card__text {
    max-height: 65vh;
    overflow: auto;
    padding-top: 32px;
  }
  .v-card__actions {
    border-top: 1px solid rgba(0, 0, 0, 0.12);
  }
  .radio-label {
    position: absolute;
    font-size: 16px;
    text-align: left;
    left: 0;
    max-width: 133%;
    height: 20px;
    line-height: 20px;
    color: rgba(0, 0, 0, 0.54);
    -webkit-transform: translateY(-18px) scale(0.75);
    transform: translateY(0px) translateX(-6px) scale(0.75);
  }
  .subheading {
    padding: 8px;
    background: white;
    color: rgba(0, 0, 0, 0.54);
    top: -36px;
    left: 8px;
    position: absolute;
    display: flex;
    align-items: center;
  }
  .form-group {
    padding: 16px;
    margin: 0 0 24px 0;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 5px;
    position: relative;
  }
  .container.grid-list-md .layout:not(:only-child) {
    margin: 0 0 24px 0;
  }
  .v-input--selection-controls.v-input .v-label {
    text-transform: capitalize;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bridgeSigning/dialog/EditBridgeSigning.vue